import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { useLazyGetImportantAnnouncementDetailsByIdQuery } from "../app/services/importantAnnouncementService";
import Spinner from "../Component/spinner/spinner";

function ViewAnnouncementDetail() {
  const { id } = useParams();
  const [getAnnouncementById] = useLazyGetImportantAnnouncementDetailsByIdQuery();
  const [announcement, setAnnouncement] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      setLoading(true);
      getAnnouncementById(id)
        .then((res) => {
          if (res?.data?.status) {
            setAnnouncement(res.data.data);
          }
        })
        .catch((err) => console.error("Error fetching announcement:", err))
        .finally(() => setLoading(false));
    }
  }, [id, getAnnouncementById]);

  // Derive files array: supports both `files: [{fileUrl, fileName}]` and legacy single `file/fileUrl`
  const getFiles = (data) => {
    if (!data) return [];
    if (Array.isArray(data.files) && data.files.length > 0) {
      const names = Array.isArray(data.fileName) ? data.fileName : [];
      return data.files.map((f, i) => ({
        url: f.fileUrl || f.base64 || "",
        name: names[i] || f.fileName || f.name || `File ${i + 1}`,
      }));
    }
    if (data.fileUrl) {
      return [{ url: data.fileUrl, name: data.fileName || "Download" }];
    }
    return [];
  };

  if (loading) return <Spinner />;

  if (!announcement) {
    return (
      <div className="p-md-5 p-3 overallPadding text-center">
        <h4 className="text-muted">Announcement not found.</h4>
        <Button
          variant="contained"
          className="menus-color mt-3"
          onClick={() => window.history.back()}
        >
          Back
        </Button>
      </div>
    );
  }

  const files = getFiles(announcement);

  return (
    <div>
      {/* Page header */}
      <div className="pt-5 pb-5">
        <div className="chapter-heading">
          <h2 className="text-center title-font text-light py-3 mt-1">
            Announcement
          </h2>
        </div>
      </div>

      <div className="p-md-5 p-3 overallPadding">
        {/* Back button */}
        <div className="d-flex justify-content-end mb-4">
          <Button
            variant="contained"
            className="menus-color"
            onClick={() => window.history.back()}
          >
            Back
          </Button>
        </div>

        <div className="card shadow-sm mx-auto" style={{ maxWidth: 860 }}>
          <div className="card-body p-4">
            {/* Expiry date badge */}
            {announcement.expiryDate && (
              <div className="mb-3">
                <span
                  className="badge"
                  style={{
                    backgroundColor: "#f5f0e8",
                    color: "#611f1e",
                    fontWeight: 600,
                    fontSize: "0.85rem",
                    padding: "6px 12px",
                    borderRadius: "4px",
                  }}
                >
                  Added On:{" "}
                  {new Date(announcement.createdAt).toLocaleDateString(
                    "en-IN",
                    { day: "numeric", month: "long", year: "numeric" }
                  )}
                </span>
              </div>
            )}

            {/* Description */}
            <div
              className="announcement-text-wrap mt-3"
              style={{ lineHeight: 1.8, fontSize: "1rem" }}
              dangerouslySetInnerHTML={{ __html: announcement.text || "" }}
            />

            {/* Files */}
            {files.length > 0 && (
              <div className="mt-4">
                <h6 className="fw-bold mb-3" style={{ color: "#611f1e" }}>
                  Attachments
                </h6>
                <div className="d-flex flex-column gap-2">
                  {files.map((f, idx) => (
                    <div
                      key={idx}
                      className="d-flex align-items-center justify-content-between border rounded px-3 py-2 bg-light"
                    >
                      <span
                        className="text-truncate me-3"
                        style={{ fontSize: "0.95rem", maxWidth: "70%" }}
                      >
                        {"\uD83D\uDCC4"} {f.name}
                      </span>
                      <a
                        href={f.url}
                        target="_blank"
                        rel="noreferrer"
                        download={f.name}
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          variant="contained"
                          className="menus-color"
                          size="small"
                          startIcon={<DownloadIcon />}
                        >
                          Download
                        </Button>
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewAnnouncementDetail;
